import { render, staticRenderFns } from "./RiddleContainer.vue?vue&type=template&id=dd340f6c&scoped=true"
import script from "./RiddleContainer.vue?vue&type=script&lang=ts"
export * from "./RiddleContainer.vue?vue&type=script&lang=ts"
import style0 from "./RiddleContainer.vue?vue&type=style&index=0&id=dd340f6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd340f6c",
  null
  
)

export default component.exports